import * as UserGroupManagementConstants from './UserGroupManagementConstants';
import {
    STATUS_SUCCESS,STATUS_PENDING,STATUS_FAILURE
  } from "Common/constants/commonConstants";
// Object.assign is not yet fully supported in all browsers, so we fallback to a polyfill
const assign = Object.assign || require('object.assign');

const initialState = {
    isuserDetailsFetching: false,
    isuserDetailsFetched: false,
    isuserDetailsFetchFailed: false,
    userData: [],
    isGroupUserDetailsFetching: false,
    isGroupUserDetailsFetched: false,
    isGroupUserDetailsFetchFailed: false,
    groupUserData: [],

    isuserDataAddedFetching : false,
    isuserDataAddedFetched: false,
    isuserDataAddedFetchFailed: false,

    isuserDataRemovalFetching : false,
    isuserDataRemovalFetched: false,
    isuserDataRemovalFetchFailed: false,

    userAssignedGroupsDataFetched:false,
    userAssignedGroupsDataFetching:false,
    userAssignedGroupsDataFetchingFailed:false,
    userAssignedGroups:[],
    
    refreshTrigger: false
}


export default function UserGroupManagementReducer(state = initialState, action) {

    switch (action.type) {

        case UserGroupManagementConstants.USER_MANAGEMENT_DATA_FETCHING:
            return assign({}, state, {
                isuserDetailsFetching: true,
                isuserDetailsFetched: false,
                isuserDetailsFetchFailed: false,
                userData: [],
                isuserDataAddedFetching : false,
                isuserDataAddedFetched: false,
                isuserDataAddedFetchFailed: false,
                isuserDataRemovalFetching : false,
                isuserDataRemovalFetched: false,
                isuserDataRemovalFetchFailed: false,
            });
            break;

        case UserGroupManagementConstants.USER_MANAGEMENT_DATA_FETCHED:
            return assign({}, state, {
                isuserDetailsFetching: false,
                isuserDetailsFetched: true,
                isuserDetailsFetchFailed: false,
                userData: action.newState.result,
                isuserDataAddedFetching : false,
                isuserDataAddedFetched: false,
                isuserDataAddedFetchFailed: false,
                isuserDataRemovalFetching : false,
                isuserDataRemovalFetched: false,
                isuserDataRemovalFetchFailed: false,
                
            });
            break;

        case UserGroupManagementConstants.USER_MANAGEMENT_DATA_FETCHING_FAILED:
            return assign({}, state, {
                isuserDetailsFetching: false,
                isuserDetailsFetched: true,
                isuserDetailsFetchFailed: false,
                userData: [],
                isuserDataAddedFetching : false,
                isuserDataAddedFetched: false,
                isuserDataAddedFetchFailed: false,
            
                isuserDataRemovalFetching : false,
                isuserDataRemovalFetched: false,
                isuserDataRemovalFetchFailed: false,
            });
            break;

            case UserGroupManagementConstants.GROUP_USER_DATA_FETCHING:
                return assign({}, state, {
                    isGroupUserDetailsFetching: true,
                    isGroupUserDetailsFetched: false,
                    isGroupUserDetailsFetchFailed: false,
                    groupUserData: []
                });
                break;
    
            case UserGroupManagementConstants.GROUP_USER_DATA_FETCHED:
                return assign({}, state, {
                    isGroupUserDetailsFetching: false,
                    isGroupUserDetailsFetched: true,
                    isGroupUserDetailsFetchFailed: false,
                    groupUserData: action.newState.result
                    
                });
                break;
    
            case UserGroupManagementConstants.GROUP_USER_DATA_FETCHING_FAILED:
                return assign({}, state, {
                    isGroupUserDetailsFetching: false,
                    isGroupUserDetailsFetched: false,
                    isGroupUserDetailsFetchFailed: true,
                    groupUserData: []
                });
                break;


                case UserGroupManagementConstants.GROUP_USER_DATA_FETCHING:
                    return assign({}, state, {
                        isGroupUserDetailsFetching: true,
                        isGroupUserDetailsFetched: false,
                        isGroupUserDetailsFetchFailed: false,
                        groupUserData: []
                    });
                    break;
        
                case UserGroupManagementConstants.GROUP_USER_DATA_FETCHED:
                    return assign({}, state, {
                        isGroupUserDetailsFetching: false,
                        isGroupUserDetailsFetched: true,
                        isGroupUserDetailsFetchFailed: false,
                        groupUserData: action.newState.result
                        
                    });
                    break;
        
                case UserGroupManagementConstants.GROUP_USER_DATA_FETCHING_FAILED:
                    return assign({}, state, {
                        isGroupUserDetailsFetching: false,
                        isGroupUserDetailsFetched: false,
                        isGroupUserDetailsFetchFailed: true,
                        groupUserData: []
                    });
                    break;

                    case UserGroupManagementConstants.GROUP_ADD_USER_FETCHING:
                        return assign({}, state, {
                            
                            isuserDataAddedFetching : true,
                            isuserDataAddedFetched: false,
                            isuserDataAddedFetchFailed: false,
                            isuserDataRemovalFetching : false,
                            isuserDataRemovalFetched: false,
                            isuserDataRemovalFetchFailed: false,
                            userAdditionFailureMessage:null,
                            groupUserData:[]
                        });
                        break;
            
                    case UserGroupManagementConstants.GROUP_ADD_USER_FETCHED:
                        return assign({}, state, {
                          
                            isuserDataAddedFetching : false,
                            isuserDataAddedFetched: true,
                            isuserDataAddedFetchFailed: false,
                            userAdditionFailureMessage:null,
                            groupUserData:[]
                        });
                        break;
            
                    case UserGroupManagementConstants.GROUP_ADD_USER_FETCHING_FAILED:
                        let message="";
                           
                        if(action.newState && action.newState.responseJSON)
                            message = action.newState.responseJSON.message 
                    
                       return assign({}, state, {
                            isuserDataAddedFetching : false,
                            isuserDataAddedFetched: false,
                            isuserDataAddedFetchFailed: true,
                            userAdditionFailureMessage:message,
                            groupUserData:[]
                        });
                        break;
                        case UserGroupManagementConstants.GROUP_REMOVE_USER_FETCHING:
                            return assign({}, state, {
                                
                                isuserDataRemovalFetching : true,
                                isuserDataRemovalFetched: false,
                                isuserDataRemovalFetchFailed: false,
                                isuserDataAddedFetching : false,
                                isuserDataAddedFetched: false,
                                isuserDataAddedFetchFailed: false,
                                userAdditionFailureMessage:null,
                                groupUserData:[]
                            });
                            break;
                
                        case UserGroupManagementConstants.GROUP_REMOVE_USER_FETCHED:{
                            
                            let message="";
                           
                            if(action.newState && action.newState.responseJSON)
                                message = action.newState.responseJSON.message

                            return assign({}, state, { 
                              
                                isuserDataRemovalFetching : false,
                                isuserDataRemovalFetched: true,
                                isuserDataRemovalFetchFailed: false,
                                userAdditionFailureMessage:message,
                                groupUserData:[]
                            });
                        }
                            break;
                
                        case UserGroupManagementConstants.GROUP_REMOVE_USER_FETCHING_FAILED:
                            return assign({}, state, {
                                isuserDataRemovalFetching : false,
                                isuserDataRemovalFetched: false,
                                isuserDataRemovalFetchFailed: true,
                                userAdditionFailureMessage:null,
                                groupUserData:[]
                            });
                            break;
                        
                            case UserGroupManagementConstants.USER_ASSIGNED_GROUP_FETCHING:
                                return assign({}, state, {
                                    
                                    userAssignedGroupsDataFetched:false,
                                    userAssignedGroupsDataFetching:true,
                                    userAssignedGroupsDataFetchingFailed:false,
                                    userAssignedGroups:[]
                                });
                                break;
                    
                            case UserGroupManagementConstants.USER_ASSIGNED_GROUP_FETCHED:{
                                
                                return assign({}, state, { 
                                  
                                    userAssignedGroupsDataFetched:true,
                                    userAssignedGroupsDataFetching:false,
                                    userAssignedGroupsDataFetchingFailed:false,
                                    userAssignedGroups:action.newState.result
                                });
                            }
                                break;
                    
                            case UserGroupManagementConstants.USER_ASSIGNED_GROUP_FETCHING_FAILED:
                                return assign({}, state, {
                                    userAssignedGroupsDataFetched:false,
                                    userAssignedGroupsDataFetching:false,
                                    userAssignedGroupsDataFetchingFailed:true,
                                    userAssignedGroups:[]
                                });
                                break;

                            case UserGroupManagementConstants.USER_ASSIGNED_GROUP_FETCHING_RESET:
                                    return assign({}, state, {
                                        userAssignedGroupsDataFetched:false,
                                        userAssignedGroupsDataFetching:false,
                                        userAssignedGroupsDataFetchingFailed:false,
                                        userAssignedGroups:[]
                                    });
                             break;

                            case UserGroupManagementConstants.ADMIN_ASSIGNED_GROUP_FETCHING:
                                    return assign({}, state, {
                                        isAdminGroupFetch:STATUS_PENDING,
                                    });
                            case UserGroupManagementConstants.ADMIN_ASSIGNED_GROUP_FETCHED:
                                    return assign({}, state, {
                                        isAdminGroupFetch:STATUS_SUCCESS,
                                        adminAssignGroups:action.newState
                                    });
                            case UserGroupManagementConstants.ADMIN_ASSIGNED_GROUP_FETCHING_FAILED:
                                    return assign({}, state, {
                                        isAdminGroupFetch:STATUS_FAILURE,
                                    });
                            
                            case UserGroupManagementConstants.REFRESH_USER_MANAGEMENT_DATA:
                                    return assign({}, state, {
                                        refreshTrigger: !state.refreshTrigger
                                    });
        default:
            return state;

    }

}